export default function(instance) {
    return {
        getInvoices() {
            return instance.get('/invoices',);
        },
        getPaymentInfo() {
            return instance.get('/payment/info',);
        },
    };
}